// Jewels Park – Product Select + PDF Generator v6
(function () {
  const selectedProducts = new Map();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
           || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // iPadOS 13+
  const canShare = isIOS && navigator.share && navigator.canShare;

  // ── Inject styles ────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    #jp-progress-overlay {
      display: none; position: fixed; inset: 0;
      background: rgba(0,0,0,0.55); z-index: 99999;
      align-items: center; justify-content: center; flex-direction: column; gap: 16px;
    }
    #jp-progress-overlay.visible { display: flex; }
    #jp-progress-box {
      background: #fff; border-radius: 12px; padding: 28px 32px;
      min-width: 280px; text-align: center;
    }
    #jp-progress-label {
      font-family: 'Jost', sans-serif; font-size: 13px; color: #444; margin-bottom: 14px;
    }
    #jp-progress-track {
      width: 100%; height: 6px; background: #eee; border-radius: 99px; overflow: hidden;
    }
    #jp-progress-fill {
      height: 100%; width: 0%; background: #1a1a1a;
      border-radius: 99px; transition: width 0.3s ease;
    }
    #jp-options-overlay {
      display: none; position: fixed; inset: 0;
      background: rgba(0,0,0,0.55); z-index: 99999;
      align-items: center; justify-content: center;
    }
    #jp-options-overlay.visible { display: flex; }
    #jp-options-box {
      background: #fff; border-radius: 12px; padding: 26px 26px 20px;
      min-width: 300px; max-width: 340px; font-family: 'Jost', sans-serif;
    }
    #jp-options-box h3 { font-size: 15px; font-weight: 600; margin: 0 0 4px; color: #1a1a1a; }
    #jp-options-box p { font-size: 11px; color: #999; margin: 0 0 16px; }
    .jp-radio-row {
      display: flex; align-items: flex-start; gap: 10px;
      padding: 11px 14px; border: 1.5px solid #eee; border-radius: 8px;
      margin-bottom: 8px; cursor: pointer;
      transition: border-color 0.2s, background 0.2s;
    }
    .jp-radio-row:hover { border-color: #bbb; }
    .jp-radio-row input[type=radio] {
      accent-color: #1a1a1a; width: 15px; height: 15px;
      flex-shrink: 0; cursor: pointer; margin-top: 1px;
    }
    .jp-radio-label { font-size: 13px; color: #333; line-height: 1.3; }
    .jp-radio-sub { font-size: 10px; color: #aaa; display: block; margin-top: 2px; }
    .jp-radio-row:has(input:checked) { border-color: #1a1a1a; background: #f8f8f8; }
    .jp-radio-row:has(input:checked) .jp-radio-label { font-weight: 500; color: #1a1a1a; }
    .jp-options-btns { display: flex; gap: 10px; margin-top: 18px; }
    .jp-options-btns button {
      flex: 1; padding: 9px; border-radius: 6px;
      font-size: 12px; font-weight: 500; cursor: pointer; font-family: 'Jost', sans-serif;
    }
    #jp-opts-cancel { background: #fff; border: 1px solid #ddd; color: #555; }
    #jp-opts-generate { background: #1a1a1a; border: none; color: #fff; }
    #jp-preview-overlay {
      display: none; position: fixed; inset: 0;
      background: rgba(0,0,0,0.7); z-index: 99999;
      align-items: center; justify-content: center; flex-direction: column; gap: 12px;
    }
    #jp-preview-overlay.visible { display: flex; }
    #jp-preview-iframe {
      width: 90vw; max-width: 900px; height: 80vh;
      border: none; border-radius: 8px; background: #fff;
    }
    #jp-preview-btns { display: flex; gap: 12px; }
    #jp-preview-btns button {
      padding: 9px 20px; border-radius: 20px;
      font-size: 13px; font-weight: 500; cursor: pointer; font-family: 'Jost', sans-serif;
    }
    #jp-preview-download { background: #fff; border: none; color: #1a1a1a; }
    #jp-preview-close { background: transparent; border: 1px solid rgba(255,255,255,0.4); color: #fff; }
    #jp-ios-sheet {
      display: none; position: fixed; inset: 0;
      background: rgba(0,0,0,0.6); z-index: 99999;
      align-items: flex-end; justify-content: center;
    }
    #jp-ios-sheet.visible { display: flex; }
    #jp-ios-sheet-box {
      background: #fff; border-radius: 16px 16px 0 0;
      padding: 24px 24px 40px; width: 100%; max-width: 480px;
      font-family: 'Jost', sans-serif; text-align: center;
    }
    #jp-ios-sheet-box h4 { font-size: 15px; font-weight: 600; margin: 0 0 8px; color: #1a1a1a; }
    #jp-ios-sheet-box p { font-size: 12px; color: #777; margin: 0 0 20px; line-height: 1.6; }
    #jp-ios-share-btn {
      display: block; width: 100%; padding: 14px;
      background: #1a1a1a; color: #fff; border: none;
      border-radius: 10px; font-size: 14px; font-weight: 600;
      font-family: 'Jost', sans-serif; cursor: pointer; margin-bottom: 10px;
    }
    #jp-ios-cancel-btn {
      display: block; width: 100%; padding: 12px;
      background: transparent; color: #999; border: none;
      font-size: 13px; font-family: 'Jost', sans-serif; cursor: pointer;
    }
  `;
  document.head.appendChild(style);

  // ── Progress overlay ─────────────────────────────
  const progressOverlay = document.createElement('div');
  progressOverlay.id = 'jp-progress-overlay';
  progressOverlay.innerHTML = `
    <div id="jp-progress-box">
      <div id="jp-progress-label">Preparing your PDF…</div>
      <div id="jp-progress-track"><div id="jp-progress-fill"></div></div>
    </div>`;
  document.body.appendChild(progressOverlay);

  function setProgress(pct, label) {
    document.getElementById('jp-progress-fill').style.width = pct + '%';
    if (label) document.getElementById('jp-progress-label').textContent = label;
  }
  function showProgress() { progressOverlay.classList.add('visible'); }
  function hideProgress() { progressOverlay.classList.remove('visible'); }

  // ── Options dialog ───────────────────────────────
  const optionsOverlay = document.createElement('div');
  optionsOverlay.id = 'jp-options-overlay';
  optionsOverlay.innerHTML = `
    <div id="jp-options-box">
      <h3>PDF Options</h3>
      <p>Choose which price to show on the PDF</p>
      <label class="jp-radio-row">
        <input type="radio" name="jp-price-opt" value="discounted" checked>
        <span class="jp-radio-label">Wholesale price<span class="jp-radio-sub">Discounted wholesale price</span></span>
      </label>
      <label class="jp-radio-row">
        <input type="radio" name="jp-price-opt" value="retail">
        <span class="jp-radio-label">Retail price<span class="jp-radio-sub">Full retail price (2× wholesale)</span></span>
      </label>
      <label class="jp-radio-row">
        <input type="radio" name="jp-price-opt" value="none">
        <span class="jp-radio-label">No price<span class="jp-radio-sub">Hide all pricing from the PDF</span></span>
      </label>
      <div class="jp-options-btns">
        <button id="jp-opts-cancel">Cancel</button>
        <button id="jp-opts-generate">Generate PDF</button>
      </div>
    </div>`;
  document.body.appendChild(optionsOverlay);

  document.getElementById('jp-opts-cancel').addEventListener('click', function () {
    optionsOverlay.classList.remove('visible');
  });
  document.getElementById('jp-opts-generate').addEventListener('click', function () {
    optionsOverlay.classList.remove('visible');
    generatePDF();
  });

  // ── Desktop preview ──────────────────────────────
  const previewOverlay = document.createElement('div');
  previewOverlay.id = 'jp-preview-overlay';
  previewOverlay.innerHTML = `
    <iframe id="jp-preview-iframe"></iframe>
    <div id="jp-preview-btns">
      <button id="jp-preview-download">⬇ Download PDF</button>
      <button id="jp-preview-close">✕ Close</button>
    </div>`;
  document.body.appendChild(previewOverlay);

  document.getElementById('jp-preview-close').addEventListener('click', function () {
    previewOverlay.classList.remove('visible');
    document.getElementById('jp-preview-iframe').src = '';
    currentPdfBlob = null;
  });
  document.getElementById('jp-preview-download').addEventListener('click', function () {
    if (!currentPdfBlob) return;
    const url = URL.createObjectURL(currentPdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'JewelsPark-Selection-' + Date.now() + '.pdf';
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
  });

  // ── iOS bottom sheet ─────────────────────────────
  const iosSheet = document.createElement('div');
  iosSheet.id = 'jp-ios-sheet';
  iosSheet.innerHTML = `
    <div id="jp-ios-sheet-box">
      <h4>✓ PDF Ready</h4>
      <p>Tap Share to send via WhatsApp, email,<br>AirDrop or save to your Files.</p>
      <button id="jp-ios-share-btn">⬆ Share PDF</button>
      <button id="jp-ios-cancel-btn">Cancel</button>
    </div>`;
  document.body.appendChild(iosSheet);

  document.getElementById('jp-ios-cancel-btn').addEventListener('click', function () {
    iosSheet.classList.remove('visible');
    currentPdfBlob = null;
  });

  document.getElementById('jp-ios-share-btn').addEventListener('click', async function () {
    if (!currentPdfBlob) return;
    const filename = 'JewelsPark-Selection-' + Date.now() + '.pdf';
    const file = new File([currentPdfBlob], filename, { type: 'application/pdf' });
    try {
      await navigator.share({ files: [file], title: 'Jewels Park Selection' });
      iosSheet.classList.remove('visible');
    } catch (err) {
      if (err.name !== 'AbortError') {
        const url = URL.createObjectURL(currentPdfBlob);
        window.location.href = url;
      }
    }
  });

  // ── Helpers ──────────────────────────────────────
  let currentPdfBlob = null;

  // ── Parse a price string like "$1,904.50" into a number ──
  function parsePriceNumber(str) {
    if (!str) return 0;
    // Remove currency symbols, commas, spaces — keep digits and decimal point
    const cleaned = str.replace(/[^0-9.]/g, '');
    return parseFloat(cleaned) || 0;
  }

  // ── Format a number back to price string like "$1,904.50" ──
  function formatPrice(num) {
    if (!num || num <= 0) return '';
    return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // ── Floating bar ─────────────────────────────────
  const bar = document.createElement('div');
  bar.id = 'jp-select-bar';
  bar.innerHTML = `
    <span id="jp-select-count">0 items selected</span>
    <button id="jp-clear-btn">Clear</button>
    <button id="jp-pdf-btn">⬇ Download PDF</button>`;
  document.body.appendChild(bar);

  const countEl  = document.getElementById('jp-select-count');
  const pdfBtn   = document.getElementById('jp-pdf-btn');
  const clearBtn = document.getElementById('jp-clear-btn');

  function updateBar() {
    const n = selectedProducts.size;
    const text = n + (n === 1 ? ' item selected' : ' items selected');
    if (countEl.textContent !== text) countEl.textContent = text;
    bar.classList.toggle('jp-bar--visible', n > 0);
    updateSelectAllBtn();
  }

  function clearSelection() {
    selectedProducts.clear();
    document.querySelectorAll('.m-product-card').forEach(function (card) {
      card.classList.remove('jp-card--selected');
      const btn = card.querySelector('.jp-select-btn');
      if (btn) btn.classList.remove('jp-selected');
    });
    updateBar();
  }

  clearBtn.addEventListener('click', clearSelection);

  pdfBtn.addEventListener('click', function () {
    if (selectedProducts.size === 0) return;
    optionsOverlay.classList.add('visible');
  });

  // ── Read one card ────────────────────
  // Used both for cards on the page and for cards parsed out of pages we
  // fetch in the background for "Select all".
  function pickImgSrc(imgEl) {
    if (!imgEl) return '';
    const direct = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '';
    if (direct && direct.indexOf('data:') !== 0) {
      return direct.indexOf('//') === 0 ? 'https:' + direct : direct;
    }
    // Lazy-loaded cards keep the real URLs in srcset — take the first one.
    const set = imgEl.getAttribute('srcset') || imgEl.getAttribute('data-srcset') || '';
    const first = set.split(',')[0].trim().split(/\s+/)[0];
    if (!first) return '';
    return first.indexOf('//') === 0 ? 'https:' + first : first;
  }

  function extractProductData(card, discountPct) {
    const titleEl  = card.querySelector('.m-product-card__title a, .m-product-card__title');
    // Wholesale price: the red sale price shown on the card
    const priceEl  = card.querySelector('.m-price-item--sale');
    // Retail price: the regular (strikethrough) price
    const origEl   = card.querySelector('.m-price-item--regular');
    const imgEl    = card.querySelector('.m-product-card__media img');
    const skuEl    = card.querySelector('.js-card__sku');
    const karatEl  = card.querySelector('.js-card__karat');
    const specsEls = card.querySelectorAll('.js-card__spec');

    // SKU and Purity are their own line at the top of each PDF card, so keep
    // them out of the spec grid or they would appear twice.
    const SPEC_SKIP = { 'sku': 1, 'purity': 1 };
    const specs = {};
    specsEls.forEach(function (spec) {
      const label = spec.querySelector('.js-card__spec-label');
      const val   = spec.querySelector('.js-card__spec-val');
      if (!label || !val) return;
      const name = label.textContent.trim();
      if (SPEC_SKIP[name.toLowerCase().replace(/[.\s]+$/, '')]) return;
      specs[name] = val.textContent.trim();
    });

    const titleText = titleEl ? titleEl.textContent.trim() : '';
    const skuText   = skuEl   ? skuEl.textContent.trim()   : '';
    const purityText = karatEl ? karatEl.textContent.trim()  : '';

    let discountPrice = priceEl ? priceEl.textContent.trim() : '';
    let retailPrice   = origEl  ? origEl.textContent.trim()  : '';

    // Cards fetched from later pages were never touched by
    // jewelspark-dynamic-pricing.js, so their sale price still carries the
    // Liquid-rendered discount. Re-apply the slab that is live on screen.
    if (typeof discountPct === 'number' && retailPrice) {
      const retailNum = parsePriceNumber(retailPrice);
      if (retailNum > 0) discountPrice = formatPrice(retailNum * (1 - discountPct / 100));
    }

    // No strikethrough price: retail is wholesale x2 (50% off).
    if (!retailPrice && discountPrice) {
      const wholesaleNum = parsePriceNumber(discountPrice);
      if (wholesaleNum > 0) retailPrice = formatPrice(wholesaleNum * 2);
    }

    return {
      key:           skuText || titleText,
      title:         titleText,
      discountPrice: discountPrice,
      retailPrice:   retailPrice,
      imgSrc:        pickImgSrc(imgEl),
      sku:           skuText,
      purity:        purityText,
      specs:         specs
    };
  }

  function syncCardState(card, key) {
    if (!card || !key) return;
    const selected = selectedProducts.has(key);
    const btn = card.querySelector('.jp-select-btn');
    if (btn) btn.classList.toggle('jp-selected', selected);
    card.classList.toggle('jp-card--selected', selected);
  }

  // ── Init cards ──────────────────────────
  function initCards() {
    document.querySelectorAll('.m-product-card').forEach(function (card) {
      const data = extractProductData(card);
      const key  = data.key || card.dataset.jpKey || Math.random().toString(36).slice(2);
      card.dataset.jpKey = key;

      // Refresh prices on an already-selected product — dynamic pricing may
      // have rewritten the card after it was first selected.
      if (selectedProducts.has(key)) {
        const existing = selectedProducts.get(key);
        if (data.discountPrice) existing.discountPrice = data.discountPrice;
        if (data.retailPrice)   existing.retailPrice   = data.retailPrice;
      }

      // Cards loaded later by infinite scroll may already be selected via
      // "Select all", so re-sync every pass — but only wire the button once.
      if (card.dataset.jpInit) { syncCardState(card, key); return; }
      card.dataset.jpInit = 'true';

      const btn = document.createElement('button');
      btn.className = 'jp-select-btn';
      btn.innerHTML = '<span class="jp-check-icon"></span>';
      btn.title = 'Select for PDF';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (selectedProducts.has(key)) {
          selectedProducts.delete(key);
        } else {
          selectedProducts.set(key, extractProductData(card));
        }
        syncCardState(card, key);
        updateBar();
      });

      const mediaEl = card.querySelector('.m-product-card__media');
      if (mediaEl) mediaEl.appendChild(btn);
      syncCardState(card, key);
    });
    updateSelectAllBtn();
  }

  // ── Select all (respects the filters in use) ───
  function getGridInfo() {
    const section = document.querySelector('[data-section-type="collection-template"]');
    if (!section) return null;
    const container = section.querySelector('[data-product-container]');
    if (!container) return null;
    return {
      section: section,
      grid:    container,
      // data-product-count is the filtered total, not the whole collection.
      total:   parseInt(section.dataset.productCount, 10) || 0,
      pages:   parseInt(container.dataset.totalPages, 10) || 1,
      loaded:  container.querySelectorAll('.m-product-card').length
    };
  }

  // Which discount slab the cart is on right now, read off a rendered card.
  function currentDiscountPct() {
    const card = document.querySelector('.m-product-card');
    if (!card) return null;
    const saleEl = card.querySelector('.m-price-item--sale');
    const regEl  = card.querySelector('.m-price-item--regular');
    const sale    = parsePriceNumber(saleEl ? saleEl.textContent : '');
    const regular = parsePriceNumber(regEl  ? regEl.textContent  : '');
    if (!sale || !regular || regular <= sale) return null;
    return Math.round((1 - sale / regular) * 100);
  }

  async function selectAll() {
    const info = getGridInfo();
    if (!info || info.total === 0) return;

    if (info.total > 200 && !confirm(
      info.total + ' products match the filters you have set.\n\n' +
      'Selecting them all takes a while and makes a large PDF. Continue?'
    )) return;

    const pct = currentDiscountPct();

    // Everything already rendered in the grid.
    info.grid.querySelectorAll('.m-product-card').forEach(function (card) {
      const data = extractProductData(card);
      const key  = data.key || card.dataset.jpKey;
      if (!key) return;
      card.dataset.jpKey = key;
      selectedProducts.set(key, data);
      syncCardState(card, key);
    });
    updateBar();

    // The rest sits on pages infinite scroll has not reached — fetch them.
    if (info.pages > 1 && selectedProducts.size < info.total) {
      const perPage   = Math.max(1, Math.ceil(info.total / info.pages));
      const firstPage = Math.floor(info.loaded / perPage) + 1;
      const lastPage  = info.pages;

      showProgress();
      setProgress(0, 'Loading products…');
      try {
        for (let page = firstPage; page <= lastPage; page++) {
          const url = new URL(window.location.href);
          url.searchParams.set('page', page);
          const res = await fetch(url.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!res.ok) throw new Error('HTTP ' + res.status);
          const parsed = new DOMParser().parseFromString(await res.text(), 'text/html');
          // Only the collection grid — a full page also carries cards from
          // recommendation / recently-viewed sections, which do not match the filters.
          const grid = parsed.querySelector('[data-product-container]');
          if (!grid) throw new Error('No product grid on page ' + page);
          grid.querySelectorAll('.m-product-card').forEach(function (card) {
            const data = extractProductData(card, pct);
            if (data.key) selectedProducts.set(data.key, data);
          });
          setProgress(
            Math.round(((page - firstPage + 1) / (lastPage - firstPage + 1)) * 100),
            'Loading ' + Math.min(selectedProducts.size, info.total) + ' of ' + info.total + '…'
          );
          updateBar();
        }
      } catch (err) {
        console.error('Select all failed:', err);
        alert('Could not load every page — ' + selectedProducts.size + ' of ' + info.total +
              ' products were selected. You can still make a PDF from these.');
      }
      hideProgress();
    }

    document.querySelectorAll('.m-product-card').forEach(function (card) {
      syncCardState(card, card.dataset.jpKey);
    });
    updateBar();
  }

  // ── Select-all button in the collection toolbar ─
  const selectAllBtn = document.createElement('button');
  selectAllBtn.id = 'jp-select-all-btn';
  selectAllBtn.type = 'button';
  selectAllBtn.textContent = 'Select all';

  selectAllBtn.addEventListener('click', function () {
    const info = getGridInfo();
    if (!info) return;
    if (allSelected(info)) clearSelection();
    else selectAll();
  });

  function allSelected(info) {
    return info.total > 0 && selectedProducts.size >= info.total;
  }

  function updateSelectAllBtn() {
    const info = getGridInfo();
    if (!info || info.total === 0) {
      if (selectAllBtn.isConnected) selectAllBtn.remove();
      return;
    }
    if (!selectAllBtn.isConnected) {
      const toolbar = document.querySelector('.m-collection-toolbar--wrapper');
      if (toolbar) toolbar.appendChild(selectAllBtn);
    }
    const done  = allSelected(info);
    const label = done ? 'Deselect all' : 'Select all';
    // Only write when it changes — textContent is a childList mutation, and the
    // MutationObserver below re-runs initCards on every mutation.
    if (selectAllBtn.textContent !== label) selectAllBtn.textContent = label;
    selectAllBtn.classList.toggle('jp-select-all--on', done);
  }

  // ── PDF Generation ───────────────────────────────
  async function generatePDF() {
    if (!window.jspdf) { alert('PDF library not loaded yet, please try again.'); return; }

    const priceOpt = document.querySelector('input[name="jp-price-opt"]:checked').value;
    showProgress();
    setProgress(5, 'Starting…');
    pdfBtn.disabled = true;

    try {
      const { jsPDF } = window.jspdf;
      const doc    = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW  = 210, pageH = 297, margin = 10, cols = 4;
      const cardW  = (pageW - margin * 2 - (cols - 1) * 4) / cols;
      const imgH   = cardW;
      // Spec grid runs 2 across; the +5 leaves room for a third row (Purity + 4 weights).
      const cardH  = imgH + (priceOpt === 'none' ? 29 : priceOpt === 'discounted' ? 41 : 35);
      const startY = 22;
      let col = 0, row = 0;

      function drawHeader() {
        doc.setFillColor(26, 26, 26);
        doc.rect(0, 0, pageW, 14, 'F');
        doc.setTextColor(245, 240, 232);
        doc.setFontSize(11); doc.setFont('helvetica', 'bold');
        doc.text('JEWELS PARK', margin, 9);
        doc.setFontSize(7); doc.setFont('helvetica', 'normal');
        doc.text('wholesale.jewelspark.com', pageW - margin, 9, { align: 'right' });
      }

      drawHeader();
      doc.setTextColor(150,150,150); doc.setFontSize(6.5);
      doc.text('Generated: ' + new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), margin, startY - 3);

      const products = Array.from(selectedProducts.values());

      for (let i = 0; i < products.length; i++) {
        const p = products[i];
        setProgress(10 + Math.round((i / products.length) * 75), 'Processing ' + (i+1) + ' of ' + products.length + '…');

        const x = margin + col * (cardW + 4);
        const y = startY + row * (cardH + 4);

        doc.setFillColor(255,255,255); doc.setDrawColor(210,210,210); doc.setLineWidth(0.3);
        doc.roundedRect(x, y, cardW, cardH, 2, 2, 'FD');

        if (p.imgSrc) {
          try {
            const imgData = await loadImageAsBase64(p.imgSrc);
            doc.addImage(imgData, 'JPEG', x+1, y+1, cardW-2, imgH-2, '', 'FAST');
          } catch(e) {
            doc.setFillColor(245,245,245); doc.rect(x+1, y+1, cardW-2, imgH-2, 'F');
          }
        }

        const textY = y + imgH + 2;
        // SKU on the left, gold purity right-aligned on the same line so the
        // card gains no height (the grid below is already tight).
        doc.setFontSize(5.5); doc.setFont('helvetica','normal'); doc.setTextColor(160,160,160);
        doc.text(p.sku || '', x+2, textY+2);
        if (p.purity) {
          doc.setFontSize(5.5); doc.setFont('helvetica','bold'); doc.setTextColor(120,120,120);
          doc.text(String(p.purity), x + cardW - 2, textY + 2, { align: 'right' });
        }
        doc.setFontSize(6); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
        doc.text(doc.splitTextToSize(p.title, cardW-4)[0] || '', x+2, textY+6);

        let priceLineY = textY + 10;
        if (priceOpt === 'discounted' && (p.discountPrice || p.retailPrice)) {
          const retail    = p.retailPrice   || formatPrice(parsePriceNumber(p.discountPrice) * 2);
          const wholesale = p.discountPrice || '';
          const retailNum = parsePriceNumber(retail);
          const whlNum    = parsePriceNumber(wholesale);
          const discPct   = retailNum > 0 ? Math.round((1 - whlNum / retailNum) * 100) : 50;

          // Retail price — struck through in grey
          if (retail) {
            doc.setFontSize(5.5); doc.setFont('helvetica', 'normal'); doc.setTextColor(160, 160, 160);
            doc.text(retail, x + 2, priceLineY);
            const retailW = doc.getTextWidth(retail);
            doc.setDrawColor(160, 160, 160); doc.setLineWidth(0.3);
            doc.line(x + 2, priceLineY - 1, x + 2 + retailW, priceLineY - 1);
            priceLineY += 4;
          }

          // Wholesale price — bold black
          if (wholesale) {
            doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(26, 26, 26);
            doc.text(wholesale, x + 2, priceLineY);
            const whlW = doc.getTextWidth(wholesale);

            // Discount % badge — filled dark pill next to the price
            const badge    = discPct + '% OFF';
            doc.setFontSize(5); doc.setFont('helvetica', 'bold');
            const badgeW   = doc.getTextWidth(badge) + 3;
            const badgeX   = x + 2 + whlW + 2;
            const badgeY   = priceLineY - 4;
            doc.setFillColor(26, 26, 26);
            doc.roundedRect(badgeX, badgeY, badgeW, 5, 1, 1, 'F');
            doc.setTextColor(255, 255, 255);
            doc.text(badge, badgeX + 1.5, priceLineY - 0.5);
            priceLineY += 5;
          }

        } else if (priceOpt === 'retail' && p.retailPrice) {
          doc.setFontSize(6.5); doc.setFont('helvetica','bold'); doc.setTextColor(26,26,26);
          doc.text(p.retailPrice, x+2, priceLineY); priceLineY += 4;
        }

        Object.keys(p.specs).slice(0,6).forEach(function(key, si) {
          const sx = x+2 + (si%2) * (cardW/2-1);
          const sy = priceLineY + Math.floor(si/2) * 5;
          doc.setFontSize(5); doc.setFont('helvetica','normal'); doc.setTextColor(150,150,150);
          doc.text(key.toUpperCase(), sx, sy);
          doc.setFontSize(5.5); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
          doc.text(String(p.specs[key]), sx, sy+3);
        });

        col++;
        if (col >= cols) {
          col = 0; row++;
          if (startY + row*(cardH+4) + cardH > pageH-margin && i < products.length-1) {
            doc.addPage(); drawHeader(); row = 0;
          }
        }
      }

      setProgress(90, 'Finalising…');
      const pageCount = doc.internal.getNumberOfPages();
      for (let pg = 1; pg <= pageCount; pg++) {
        doc.setPage(pg); doc.setFontSize(6); doc.setTextColor(180,180,180);
        doc.text('Page ' + pg + ' of ' + pageCount, pageW/2, pageH-5, { align:'center' });
      }

      setProgress(100, 'Done!');
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('jp_pdf_export', { productCount: products.length, page: location.pathname + location.search, priceOption: priceOpt }); } catch (e) {} // export record for Customer Events

      const pdfArrayBuffer = doc.output('arraybuffer');
      currentPdfBlob = new Blob([pdfArrayBuffer], { type: 'application/pdf' });

      setTimeout(function () {
        hideProgress();
        pdfBtn.disabled = false;

        if (isIOS) {
          iosSheet.classList.add('visible');
        } else {
          const url = URL.createObjectURL(currentPdfBlob);
          document.getElementById('jp-preview-iframe').src = url;
          previewOverlay.classList.add('visible');
        }
      }, 400);

    } catch(err) {
      console.error('PDF error:', err);
      hideProgress();
      pdfBtn.disabled = false;
      alert('Something went wrong. Please try again.');
    }
  }

  function loadImageAsBase64(src) {
    return new Promise(function(resolve, reject) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
        canvas.getContext('2d').drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg', 0.85));
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  document.addEventListener('DOMContentLoaded', initCards);
  window.addEventListener('load', function() {
    initCards();
    setTimeout(initCards, 800);
    setTimeout(initCards, 2000);
  });
  const jpCardObserver = new MutationObserver(initCards);
  jpCardObserver.observe(document.body, { childList: true, subtree: true });

})();